module.exports = __webpack_public_path__ + "img/clear.176d717d.svg";